export function productListingDate(value) {
    if (!value) return '';
    if (!value.includes('T') && !value.endsWith('Z')) return value.replace(' ', 'T');
    const date = new Date(value);
    if (isNaN(date.getTime())) return '';
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Asia/Kuala_Lumpur', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
    }).formatToParts(date).map(part => [part.type, part.value]));
    return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}`;
}

export const productModel = (data = {}) => ({
    uuid: data.uuid, name: data.name || '', description: data.description || '',
    image: data.image || '', price: data.price ?? '', availableStock: data.available_stock === undefined ? 0 : data.available_stock,
    listingEndDate: productListingDate(data.listing_end_date), expiryDate: data.expiry_date || '',
    pdfUrl: data.pdf_url || '', isActive: data.is_active === true || data.is_active === 1 || data.is_active === '1',
    categoryUUID: data.product_category?.uuid || '', categoryName: data.product_category?.name || '',
    conditionUUID: data.product_condition?.uuid || '', conditionName: data.product_condition?.name || '',
    company: data.pic_company || null, companyUUID: data.pic_company?.uuid || '',
    picUser: data.pic_user || null, picUserUUID: data.pic_user?.uuid || '',
    companyName: data.pic_company?.name || '',
    picUserName: [data.pic_user?.first_name, data.pic_user?.last_name].filter(Boolean).join(' '),
    tags: (data.product_tags || []).map(tag => tag.name),
    productImages: data.product_images || [], variations: (data.product_variations || []).map(row => ({
        ...row, is_active: row.is_active === true || row.is_active === 1 || row.is_active === '1',
    })),
    favourites: data.fav_number ?? 0,
});
